export default "__VITE_ASSET__d055328e__"